import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-dashboard-muted italic"
}
const _hoisted_3 = { class: "px-3 py-1.5 bg-dashboard-bg border-b border-dashboard-border" }
const _hoisted_4 = { class: "font-mono text-xs font-semibold text-dashboard-text" }
const _hoisted_5 = { class: "divide-y divide-dashboard-border" }
const _hoisted_6 = { class: "px-3 py-2 flex gap-2 text-xs" }
const _hoisted_7 = { class: "font-mono text-dashboard-text break-all flex-1" }
const _hoisted_8 = { class: "px-3 py-2 flex gap-2 text-xs" }
const _hoisted_9 = { class: "font-mono text-dashboard-text break-all flex-1" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DiffView',
  props: {
    before: {},
    after: {}
  },
  setup(__props: any) {

const props = __props

const changedKeys = computed(() => {
  const keys = new Set([...Object.keys(props.before), ...Object.keys(props.after)])
  const diff: string[] = []
  for (const k of keys) {
    if (JSON.stringify(props.before[k]) !== JSON.stringify(props.after[k])) {
      diff.push(k)
    }
  }
  return diff.sort()
})

function formatValue(v: any): string {
  if (v === undefined || v === null) return '—'
  if (typeof v === 'object') return JSON.stringify(v)
  return String(v)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!changedKeys.value.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Pas de différences détectées entre avant et après. "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changedKeys.value, (key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "bg-white border border-dashboard-border rounded-md overflow-hidden"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(key), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-medium text-red-700 uppercase tracking-wide" }, "avant", -1)),
            _createElementVNode("code", _hoisted_7, _toDisplayString(formatValue(_ctx.before[key])), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-medium text-emerald-700 uppercase tracking-wide" }, "après", -1)),
            _createElementVNode("code", _hoisted_9, _toDisplayString(formatValue(_ctx.after[key])), 1)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})